import { render, staticRenderFns } from "./IconUsp.vue?vue&type=template&id=54d4185a&"
import script from "./IconUsp.vue?vue&type=script&lang=js&"
export * from "./IconUsp.vue?vue&type=script&lang=js&"
import style0 from "./IconUsp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports